module.exports = __webpack_public_path__ + "img/icon_improve_info.b4f84dba.png";